"use client";

/**
 * Markdown Renderer
 *
 * Renders markdown via the shared `marked` instance and feeds the resulting
 * HTML into `.markdown-content`, whose CSS handles every element (h1-h4, p,
 * code, pre, lists, tables, links, etc.). One configured parser + one CSS
 * surface keeps every markdown site (TextBlock, file viewers, skill bodies,
 * abilities pages) visually consistent.
 */

import { memo, useMemo } from "react";
import { renderMarkdown } from "@/lib/markdown";
import { cn } from "@/lib/utils";
import "./MarkdownRenderer.css";

interface MarkdownRendererProps {
  content: string;
  className?: string;
}

export const MarkdownRenderer = memo(function MarkdownRenderer({
  content,
  className = "",
}: MarkdownRendererProps) {
  const html = useMemo(() => renderMarkdown(content), [content]);

  return (
    <div
      className={cn("markdown-content", className)}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
});
